module.exports = __webpack_public_path__ + "img/coinbankB04.e375d9da.jpg";